require('./init.js');
require('./slickSlider.js');
// Sass
require('./../sass/index.sass');